import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import barcodeIcon from "../../images/BarcodeScanner.png";
import { fetchBasket } from "../../services/basket/actions";
import { loginAPI } from "../../services/login/actions";
import "./Catalogus.scss";

function CatalogusAddBarcode(props) {
  useEffect(() => {
    props.fetchBasket(props.currentLocation.id, props.userId);
    // eslint-disable-next-line
  }, [props.currentLocation, props.userId]);

  const { data, columnsMapping } = props;
  if (!data.length) {
    return <p align="center">Geen producten om weer te geven...</p>;
  }
  if (data && columnsMapping) {
    return (
      <div>
        <List className="root">
          {data.map((rowData) => (
            <LazyLoad placeholder="Loading">
              <div>
                <ListItem style={{ justifyContent: "space-between" }}>
                  <ListItemText primary={rowData.name} />
                  <Link
                    to={{
                      pathname: "/addbarcodescanner",
                      state: { from: rowData },
                    }}
                  >
                    <ListItem
                      button
                      style={{ marginRight: 0, height: 100, width: 100 }}
                    >
                      <img
                        src={barcodeIcon}
                        style={{
                          height: 100,
                          width: 100,
                        }}
                      />
                    </ListItem>
                  </Link>
                </ListItem>

                <Divider variant="inset" component="li" />
              </div>
            </LazyLoad>
          ))}
        </List>
      </div>
    );
  } else {
    return (
      <Box p={1}>
        <h1>Geen producten</h1>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLocation: state.currentInformation.current_location,
    userId: state.login.data.user_id,
    basketProducts: state.basket.products,
  };
}

export default connect(mapStateToProps, {
  loginAPI,
  fetchBasket,
})(CatalogusAddBarcode);
